// extracted by mini-css-extract-plugin
export default {"FontUploader":"styles_FontUploader__KInfy"};